import { useSelector } from 'react-redux'
import { PhoneCallType } from 'store/slice/call-detail/types'
import { RootState } from 'store/store'

import CallSubmissionFormContentHeader from './call-submission-form-content-header'
import CriticismAndOtherSubmissionForm from './criticism-and-other-submission-form'
import FormSubmissionActions from './form-submission-actions'
import LeadAndSourceSubmissionForm from './lead-and-source-submission-form'
import OperatorsContainer from './operators-container'
import TransferSubmissionForm from './transfer-submission-form'

const CallSubmissionFormContent = () => {
  const callType = useSelector(
    (state: RootState) => state.callDetail.formData.callType
  )

  const getForm = () => {
    switch (callType) {
      case PhoneCallType.LEAD:
        return <LeadAndSourceSubmissionForm />
      case PhoneCallType.SOURCE:
        return <LeadAndSourceSubmissionForm />
      case PhoneCallType.CRITICISM:
        return <CriticismAndOtherSubmissionForm isShowSelectTopic={false} />
      case PhoneCallType.TRANSFER:
        return <TransferSubmissionForm />
      case PhoneCallType.OTHER:
        return <CriticismAndOtherSubmissionForm isShowSelectTopic={true} />
      default:
        return <LeadAndSourceSubmissionForm />
    }
  }

  return (
    <div className="xl:px-8 px-4 pt-4 pb-5  grid grid-cols-2 gap-4 border-none">
      <div className="border-1 border-[#D8D8D8] rounded-2 p-3 xl:p-5 flex flex-col max-h-[41rem]">
        <CallSubmissionFormContentHeader />
        {getForm()}
      </div>
      <div className="border-1 border-[#D8D8D8] rounded-2 p-5 pb-0 relative max-h-[40rem]">
        <p className="text-title mb-4">لیست کارشناسان</p>
        <OperatorsContainer />
      </div>
      <FormSubmissionActions />
    </div>
  )
}

export default CallSubmissionFormContent
